var title = {
    init: function () {
        let titles = helper.element("h1", true);
        if (titles) {
            Array.prototype.forEach.call(titles, title => {
                if (title) {
                    let cnt = 0;
                    let ln = title.innerText.length;
                    let i = 0;

                    title.innerHTML = title.innerText
                        .split("")
                        .map((char) => {
                            if (cnt > Math.floor(ln / 2)) {
                                i++;
                            } else {
                                if (cnt < Math.ceil(ln / 2)) {
                                    i--;
                                }
                            }
                            cnt++;
                            return `<span class="char char-${Math.abs(i)}">${char}</span>`;
                        })
                        .join("");
                }
            });
        }

    }
};
